const percentageCalculator = (discount, currentPrice) => {
    return currentPrice - (currentPrice * discount / 100)
}

export default percentageCalculator;
